import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { useGuideTour } from '../provider/guideTourContext'
import { selectGuideTourActivation } from './utils'
import { GuideTourStepRouteNavigator } from './GuideTourStepRouteNavigator'
import { GuideTourPendingLaunchNavigator } from './GuideTourPendingLaunchNavigator'
import { useGuideTourActivation } from './activation'

export const GuideTourRouteListener = () => {
  const { pathname } = useLocation()
  const { state, registry, setCurrentPathname, refreshGuideTourNotifications } =
    useGuideTour()

  useEffect(() => {
    setCurrentPathname(pathname)
    refreshGuideTourNotifications()
  }, [setCurrentPathname, pathname, refreshGuideTourNotifications])

  const activation = selectGuideTourActivation(pathname, registry, state)

  useGuideTourActivation(activation?.tour, {
    stepIndex: activation?.stepIndex,
    viewedStepCount: activation?.viewedStepCount,
    pathname,
  })

  return (
    <>
      <GuideTourStepRouteNavigator />
      <GuideTourPendingLaunchNavigator />
    </>
  )
}
